<template>
  <div class="container">
    <div class="main">
      <div class="main1">
        <main1 />
      </div>
      <div class="main2">
        <main2 />
      </div>
    </div>
    <div class="footer1">
      <footer1 />
    </div>
    <div class="footer2">
      <footer2 />
    </div>
  </div>

</template>

<script>
import main1 from "./components/main1.vue";
import main2 from "./components/main3.vue";
import footer1 from "./components/footer1.vue";
import footer2 from "./components/footer2.vue";

export default {
  name: "App",
  components: {
    main1,
    main2,
    footer1,
    footer2
  }
};
</script>

<style>
/* * {
  border: 1px solid black;
} */
html,
body {
  margin: 0px;
  height: 100%;
}
#app {
  height: 100%;
}

.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.main {
  flex-grow: 1;
}
.main1,
.main2 {
  height: 100%;
}
.footer1 {
  background: #787878;
  height: 18%;
}
.footer2 {
  background: #787878;
  height: 8%;
  max-height: 60px;
  display: none;
}
.main2 {
  display: none;
}

@media screen and (min-width: 600px) {
  .footer1,
  .main1 {
    display: none;
  }
  .footer2,
  .main2 {
    display: block;
  }
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
    color: rgb(232, 196, 196);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
    color: rgb(216, 232, 193);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
    color: rgb(213, 190, 237);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
    color: rgb(189, 221, 235);
  }
}
</style>
